export default class ObjClass{
    constructor(json){
        this._populate(json);
    }

    _populate(json){
        for(let p in json){
            let tp = this._transformProp(p);
            if(tp instanceof Array){
                for(let i=0; i < tp.length; i++){
                    this[tp[i]] = json[p];
                }
            }else{
               this[tp] = json[p]; 
            }            
        }
    }

    _transformProp(p){
        return p;
    }
}


// WEBPACK FOOTER //
// ./src/api/ObjClass.js